import {createRoot, hydrateRoot} from 'react-dom/client';
import SupplierAndBuyerPortal from '../pages/SupplierAndBuyerPortal/SupplierAndBuyerPortal'
import "../index.css";
import "../pages/SupplierAndBuyerPortal/SupplierAndBuyerPortal.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SupplierAndBuyerPortal {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SupplierAndBuyerPortal {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SupplierAndBuyerPortalVC = {mount, hydrate, unmount}